exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width:768px){h2[data-v-5a24ae29]{font-size:24px}h4[data-v-5a24ae29]{font-size:20px}}.button-container[data-v-5a24ae29]{display:flex;flex-wrap:wrap}.spacing[data-v-5a24ae29]{flex-grow:1}.accept-btn-container[data-v-5a24ae29],.reject-btn-container[data-v-5a24ae29]{text-align:center}@media (max-width:400px){.button-container[data-v-5a24ae29]{display:block}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5a24ae29","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/global-dialogs/ConfirmDialog.vue
// module id = 616
// module chunks = 38